/** Pulse LiveKit room data: Direct live insight cards under the user PiP. */

export const PULSE_INSIGHT_CARD = 'pulse.insight_card';

export type InsightMetric = {
  key: string;
  label: string;
  value: number;
  format?: string;
};

export type InsightBar = {
  id: string;
  label: string;
  value: number;
  max: number;
};

export type InsightCardPayload = {
  type: typeof PULSE_INSIGHT_CARD;
  v: number;
  cardId: string;
  revision: number;
  toolName?: string;
  headline: string;
  metrics: InsightMetric[];
  bars: InsightBar[];
  ttlMs?: number;
  asOf?: string;
  layout?: string;
  sessionId?: string;
};

export function parseInsightCard(msg: unknown): InsightCardPayload | null {
  if (!msg || typeof msg !== 'object') return null;
  const m = msg as Record<string, unknown>;
  if (m.type !== PULSE_INSIGHT_CARD) return null;
  const cardId = String(m.cardId || '').trim();
  if (!cardId) return null;
  const revision = Number(m.revision);
  if (!Number.isFinite(revision) || revision < 1) return null;
  const metrics = Array.isArray(m.metrics)
    ? (m.metrics as InsightMetric[]).filter(
        (row) => row && typeof row === 'object' && typeof row.value === 'number',
      )
    : [];
  const bars = Array.isArray(m.bars)
    ? (m.bars as InsightBar[]).filter(
        (row) => row && typeof row === 'object' && typeof row.value === 'number',
      )
    : [];
  if (!metrics.length && !bars.length) return null;
  return {
    type: PULSE_INSIGHT_CARD,
    v: Number(m.v) || 1,
    cardId,
    revision,
    toolName: m.toolName != null ? String(m.toolName) : undefined,
    headline: String(m.headline || cardId),
    metrics,
    bars,
    ttlMs: typeof m.ttlMs === 'number' ? m.ttlMs : 45000,
    asOf: m.asOf != null ? String(m.asOf) : undefined,
    layout: m.layout != null ? String(m.layout) : undefined,
    sessionId: m.sessionId != null ? String(m.sessionId) : undefined,
  };
}
